import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";

import ArrowNextIcon from "./icon-arrow-next.svg";
import CloseIcon from "./icon-close.svg";

export const Header = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: flex-start;

  min-block-size: 56px;
  padding: 20px;

  color: #ffffff;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  background: #000000;
`;

export const NewsletterLabel = styled.span`
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
`;

export const Title = styled.span``;

export const StyledCloseIcon = styled(CloseIcon)`
  fill: #ffffff;
`;

export const CloseButton = styled.button`
  inline-size: 20px;
  block-size: 20px;
  margin-inline-start: 20px;

  background-color: transparent;

  cursor: pointer;

  ${touchOptimizedStyles};
`;

export const StyledArrowNextIcon = styled(ArrowNextIcon)`
  inline-size: 32px;
  block-size: 32px;
`;

export const Footer = styled.div`
  position: absolute;
  inset-block-end: 0;

  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  inline-size: 100vw;
  padding: 20px;

  background-color: rgba(69, 133, 255, 0.9);
`;

export const FooterText = styled.div`
  color: #ffffff;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
`;
export const StyledIframe = styled.iframe`
  inline-size: 100%;
  block-size: calc(100vh - 56px);
`;
